import styled from 'styled-components';
import { Input } from 'reactstrap';

export default styled(Input)`
  appearance: none;
  opacity: 0;
`;
